module.exports = __webpack_public_path__ + "img/default-logo.290cb67e.png";